import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'SearchResultsTable' })({
    container: {
        border: '1px solid #EEEEEE',
        borderRadius: 16,
        paddingBottom: 20,
        paddingLeft: 20,
        paddingRight: 20,
        width: 'initial'
    },
    table: {
        tableLayout: 'auto'
    },
    header: {
        '& th': {
            fontWeight: 500,
            color: '#8E8E8E',
            fontSize: 14,
            lineHeight: '150%',
            whiteSpace: 'nowrap'
        }
    },
    body: {
        '& td': {
            color: '#232323',
            fontWeight: 500,
            fontSize: 14,
            lineHeight: '150%'
        }
    },
    row: {},
    tooltip: {
        display: 'flex',
        width: 436,
        padding: 16,
        flexWrap: 'wrap',
        gap: 16,
        borderRadius: 16,
        background: '#FFF',
        boxShadow: '0px 10px 40px 0px rgba(176, 178, 186, 0.20)'
    },
    _interactive: {
        cursor: 'pointer'
    },
    avatar: {
        width: 24,
        height: 24
    },
    title: {
        overflow: 'hidden',
        color: '#232323',
        textOverflow: 'ellipsis',
        fontSize: 14,
        fontWeight: 700,
        lineHeight: '150%',
        display: 'block',
        whiteSpace: 'nowrap'
    },
    description: {
        overflow: 'hidden',
        color: '#232323',
        textOverflow: 'ellipsis',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '150%',
        display: 'block',
        whiteSpace: 'nowrap'
    },
    seen: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        color: '#232323',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '150%',
        '& svg': {
            width: 16,
            height: 16
        }
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 8,
        color: '#8E8E8E'
    },
    link: {
        color: 'inherit',
        textDecoration: 'none'
    },
    vulnerability: {
        display: 'grid',
        flexDirection: 'column',
        minWidth: 280
    },
    inWild: {
        maxWidth: 80
    }
});
